import React from "react";
import { ChevronRight, AlertTriangle } from "lucide-react";

// Helper function for formatting
const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export function SavingsSummary({
  savings,
  savingsPct,
  showAdminFeeWarning,
  viewProposal,
}) {
  return (
    <div className="flex items-center justify-between" data-testid="savings-summary">
      <div className={`flex items-center gap-6 px-6 py-4 rounded-xl ${savings > 0 ? "bg-emerald-50 border border-emerald-200" : savings < 0 ? "bg-red-50 border border-red-200" : "bg-slate-50 border border-slate-200"}`}>
        <div>
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1">Projected Savings</div>
          <div className={`text-2xl font-bold font-mono ${savings > 0 ? "text-emerald-600" : savings < 0 ? "text-red-600" : "text-slate-600"}`}>
            {fmt(savings)}
          </div>
        </div>
        <div className={`text-lg font-bold font-mono ${savings > 0 ? "text-emerald-600" : savings < 0 ? "text-red-600" : "text-slate-600"}`}>
          ({savingsPct}%)
        </div>
      </div>
      <div className="flex flex-col items-end gap-2">
        {showAdminFeeWarning && (
          <div className="flex items-center gap-2 text-red-600 text-sm bg-red-50 px-4 py-2 rounded-lg border border-red-200">
            <AlertTriangle size={16} />
            <span className="font-medium">Please enter a Proposed Admin Fee before viewing the proposal.</span>
          </div>
        )}
        <button
          data-testid="view-proposal-btn"
          onClick={viewProposal}
          className="flex items-center gap-2 px-6 py-3 bg-[#3c68ff] text-white rounded-lg text-sm font-semibold hover:bg-[#2b4bca] transition-all shadow-sm"
        >
          View Proposal <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
